import { render, staticRenderFns } from "./ScbEasy.vue?vue&type=template&id=5a951bf0&scoped=true"
import script from "./ScbEasy.vue?vue&type=script&lang=js"
export * from "./ScbEasy.vue?vue&type=script&lang=js"
import style0 from "./ScbEasy.vue?vue&type=style&index=0&id=5a951bf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a951bf0",
  null
  
)

export default component.exports